import {
  ApiBlueprint,
  createApiFactory,
  createApiRef,
  configApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
} from '@backstage/frontend-plugin-api';
import {
  OAuthApi,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';

/**
 * ApiRef for the Authentik-backed OIDC provider.
 *
 * Backstage's `core-plugin-api` ships ApiRefs for Google/GitHub/Microsoft/Okta
 * but NOT a generic OIDC one — we register our own here, backed by `OAuth2`
 * (which implements `OAuthApi`, `OpenIdConnectApi`, `ProfileInfoApi`,
 * `BackstageIdentityApi`, `SessionApi`).
 *
 * The provider id `oidc` matches the backend provider configured in
 * `app-config.production.yaml` (`auth.providers.oidc`) and the redirect URI
 * registered in Authentik (`/api/auth/oidc/handler/frame`).
 */
export const oidcAuthApiRef = createApiRef<
  OAuthApi &
    OpenIdConnectApi &
    ProfileInfoApi &
    BackstageIdentityApi &
    SessionApi
>({
  id: 'auth.oidc',
});

export const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc-auth',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          configApi: configApiRef,
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
        },
        factory: ({ configApi, discoveryApi, oauthRequestApi }) =>
          OAuth2.create({
            configApi,
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: 'oidc',
              title: 'Mereka SSO',
              icon: () => null,
            },
            environment: configApi.getOptionalString('auth.environment'),
            defaultScopes: ['openid', 'email', 'profile'],
          }),
      }),
    ),
});
